import { getFromImmutableState } from '../../../../utils/immutableUtils';

const _getOperators = (state) => state.get('operators');
export const getMatchedOperators = getFromImmutableState(_getOperators);
